var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21 12.75c.968 0 1.75-.784 1.75-1.75v-6c0-.966-.782-1.75-1.75-1.75h-2c-.414 0-.75.336-.75.75v8c0 .414.336.75.75.75zm0-1.5h-1.25v-6.5h1.25c.138 0 .25.112.25.25v6c0 .138-.112.25-.25.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 12.75c.414 0 .75-.336.75-.75v-8c0-.414-.336-.75-.75-.75h-2c-.968 0-1.75.784-1.75 1.75v6c0 .966.782 1.75 1.75 1.75zm-.75-1.5h-1.25c-.138 0-.25-.112-.25-.25v-6c0-.138.112-.25.25-.25h1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.25 14v2c0 .414.336.75.75.75s.75-.336.75-.75v-2c0-.414-.336-.75-.75-.75s-.75.336-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 12.75c.414 0 .75-.336.75-.75v-8c0-.414-.336-.75-.75-.75h-14c-.414 0-.75.336-.75.75v8c0 .414.336.75.75.75h5c.414 0 .75-.336.75-.75v-1c0-.138.112-.25.25-.25h2c.138 0 .25.112.25.25v1c0 .414.336.75.75.75zm-.75-1.5h-3.5v-.25c0-.966-.782-1.75-1.75-1.75h-2c-.968 0-1.75.784-1.75 1.75v.25h-3.5v-6.5h12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 20.75c.968 0 1.75-.784 1.75-1.75v-7c0-.414-.336-.75-.75-.75h-7c-.414 0-.75.336-.75.75v1c0 .138-.112.25-.25.25h-2c-.138 0-.25-.112-.25-.25v-1c0-.414-.336-.75-.75-.75h-7c-.414 0-.75.336-.75.75v7c0 .966.782 1.75 1.75 1.75zm0-1.5h-16c-.138 0-.25-.112-.25-.25v-6.25h5.5v.25c0 .966.782 1.75 1.75 1.75h2c.968 0 1.75-.784 1.75-1.75v-.25h5.5v6.25c0 .138-.112.25-.25.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.e523c0d3cb4471e7684e03a4eb36ef5d.svg";
export { ForwardRef as ReactComponent };